import React from "react";
import { useTranslation } from "react-i18next";
import useAppNavigate from "../../hooks/useAppNavigate";
import { Forward, forwardArrow } from "../../common/imagePath";
import ListItem from "../../components/widgets/list_item";
import ThemeToggle from "../../components/widgets/theme_toggle";
import useIsDarkMode from "../../hooks/useIsDarkMode";

const HowToUseApp = () => {
  const navigate = useAppNavigate();
  const isDarkMode = useIsDarkMode();
  const { t } = useTranslation();

  const HOW_TO_ITEMS = [
    { key: "addTransactions", route: "/how-to-add-transactions" },
    { key: "setBudget", route: "/how-to-set-budget" },
    { key: "connectBank", route: "/how-to-connect-bank" },
    { key: "uploadStatements", route: "/how-to-upload-bank-statement" },
    { key: "addSubscription", route: "/how-to-add-bills" },
    { key: "addIOU", route: null },
    { key: "scanReceipt", route: "/how-to-scan-receipt" },
  ];

  return (
    <div className="min-h-screen bg-[#F2F2F7] dark:bg-[#000000] transition-colors duration-200">
      {/* ── Navbar ── */}
      <div className="flex items-end justify-between px-4 h-[78px] pb-5 bg-white border-b dark:bg-black dark:border-gray-600 transition-colors duration-200">
        {/* Left: back + title */}
        <div className="flex items-center gap-2 ">
          <button
            onClick={() => navigate(-1)}
            aria-label={t("common.goBack")}
            className="p-1 -ml-1 rounded-full text-[#1C1C1E] dark:text-white active:bg-black/5 dark:active:bg-white/10 transition-colors duration-200"
          >
            <img
              src={isDarkMode ? Forward : forwardArrow}
              alt="Back"
              className="w-5 h-5 text-2xl"
            />
          </button>

          <h1 className="font-inter font-semibold text-black dark:text-white transition-colors duration-200 text-18 leading-none">
            {t("howToUseApp.title")}
          </h1>
        </div>

        {/* Right: theme toggle */}
        <ThemeToggle />
      </div>

      {/* Cards for how to use App */}
      <div className="  mx-4 mt-3 font-semibold text-base text-black dark:text-white  rounded-2xl overflow-hidden bg-[#FFFFFF] dark:bg-[#1C1C1E] transition-colors duration-200 ">
        {HOW_TO_ITEMS.map((item) => (
          <ListItem
            key={item.key}
            label={t(`howToUseApp.items.${item.key}`)}
            onClick={() => {
              if (item.route) navigate(item.route);
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default HowToUseApp;
